<header class="main-bar admin-header guest tetetetete">
  <a [href]="delivery?.partner?.partnerShopUrl || 'https://deluxy.it'" target="_blank" class="guest">
    <img 
      [src]="delivery?.partner?.saleImage || 'assets/img/deluxy_nuovo_logo_2-157w.webp'"
      alt="no-image" 
      class="logo-img left"
    >
  </a>
</header>
<div class="container top-margin mb-20">
  <div *ngIf="delivery; else noDeliveryDetails">
    <div class="header">
      <h2 class="title">
        Grazie per il tuo acquisto. Il tuo ordine è stato confermato
      </h2>
    </div>

    <div class="order-details">
      <div class="detail-item">
        <span class="label">ID dell'ordine:</span>
        <span class="value">#{{ delivery?.id }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Tempo di consegna stimato:</span>
        <span class="value">
          {{ delivery?.deliveryDate | date:'fullDate' | titlecase }}
          {{ delivery?.fromTime && delivery?.toTime ? ' | ' : '' }}
          {{ delivery?.fromTime }} 
          {{ delivery?.toTime || 'N/A' }}
        </span>
      </div>
      <div class="detail-item">
        <span class="label">Stato:</span><span class="value">{{ showingCurrentStatus  }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Indirizzo di consegna:</span
        ><span class="value">{{ delivery?.address || "N/A" }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Cognome destinatario:</span
        ><span class="value">{{ delivery?.surname || "N/A" }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Nome destinatario:</span
        ><span class="value">{{ delivery?.name || "N/A" }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Citofono:</span
        ><span class="value">{{ delivery?.intercom || "N/A" }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Telefono destinatario:</span
        ><span class="value">{{ delivery?.receiverPhone || "N/A" }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Nota:</span
        ><span class="value">{{ delivery?.notes || "N/A" }}</span>
      </div>
    </div>

    <div class="tracker-step-bar-wrapper">
      <ul class="tracker-step-bar">
        <li *ngFor="let step of steps; let i = index" 
          [value]="i" 
          [ngClass]="{
            active: isStepActive(i), 
            'not-delivered': isStepNotDelivered(i) 
          }"
        >
        <span class="icon">
          <i [ngClass]="step.icon"></i>
        </span>
        <span 
          class="label" 
          [ngClass]="{
            'active-color': isStepActive(i),
            'inactive-color': !isStepActive(i),
            'not-delivered-color': isStepNotDelivered(i)
          }"
        >
          {{ step.label }}
        </span>
        </li>
      </ul>
    </div>
    <div class="order-summary">

      <ng-container *ngFor="let item of delivery?.deliveryProducts">
        <div class="product-item">
          <div class="product-image">
            <img
              [src]="item?.product?.image || 'assets/img/no-image.jpg'"
              [alt]="item?.product?.name || 'Prodotto'"
            />
          </div>
          <div class="product-info">
            <h4 class="product-name">
              {{ item?.product?.name }}
              <ng-container *ngIf="item?.productVariant?.variantName">
                ({{ item.productVariant.variantName }})
              </ng-container>
            </h4>
            <p class="product-price">
              {{
                item?.productVariant?.variantPrice ||
                  item?.product?.price ||
                  0 | currency : "EUR"
              }}
            </p>
          </div>
          <div class="product-quantity">
            <span>× {{ item?.quantity || 1 }}</span>
          </div>
        </div>
      </ng-container>

      <div class="order-total">
        <div class="subtotal">
          <span>Totale parziale</span>
          <span>{{ subtotal || 0 | currency : "EUR" }}</span>
        </div>
        <div class="shipping">
          <span>Spedizione</span>
          <span>{{ shippingPrice || 0 | currency : "EUR" }}</span>
        </div>
        <div class="tax">
          <span>Tasse</span>
          <span>{{ taxPrice || 0 | currency : "EUR" }}</span>
        </div>
        <div class="total">
          <span>Totale</span>
          <span>{{ totalPrice || 0 | currency : "EUR" }}</span>
        </div>
      </div>
    </div>
    <a [href]="delivery?.partner?.partnerShopUrl || 'https://deluxy.it'" target="_blank" class="shop-more-btn">
      Continua a fare acquisti <i class="fas fa-arrow-right"></i>
    </a>

    <span *ngIf="delivery?.serviceType?.toLowerCase() === 'fixedprice' || delivery?.serviceType?.toLowerCase() === 'hourlyrate'">
      <a [href]="'tel:' + delivery?.partner?.phone" class="shop-more-btn">
        Contatta la Boutique <i class="ml-10 fas fa-phone"></i>
      </a>
    </span>
  </div>

  <ng-template #noDeliveryDetails>
    <div class="header">
      <h2 class="title">Consegna non trovata.</h2>
    </div>
    <a href="https://deluxy.it" target="_blank" class="shop-more-btn">
      Continua a fare acquisti <i class="fas fa-arrow-right"></i>
    </a>
  </ng-template>
</div>
